var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRideChosen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 186,
    height: 91,
    viewBox: "0 0 186 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#13647b}.cls-3{fill:#4b4b4b}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ride_Chosen",
    transform: "translate(-1038 -433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_821",
    fill: "none",
    d: "M0 0H186V91H0z",
    transform: "translate(1038 433)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_503",
    transform: "translate(-8289.184 -666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2431",
    d: "M9171.111 393.917h19.933l-1.452 4.36h-16.2z",
    className: "cls-2",
    transform: "translate(192.671 764.872)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73",
    cx: 15,
    cy: 15,
    r: 15,
    className: "cls-2",
    transform: "translate(9419 1140)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74",
    cx: 15,
    cy: 15,
    r: 15,
    className: "cls-2",
    transform: "translate(9463 1140)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon_scooter",
    transform: "translate(9347.184 1123.412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    d: "M51.577 49.987a5.352 5.352 0 0 1-4.891-3.1v-.108l-2.186.527H27.012a.789.789 0 0 1-.676-.387l-8.964-16.045-1.038 6.2h.11a7.886 7.886 0 0 1 5.8 8.627.766.766 0 0 1-.755.666.792.792 0 0 1-.575-.259.767.767 0 0 1-.2-.593 6.91 6.91 0 0 0 0-.805 6.376 6.376 0 0 0-4.545-6.2h-.157l-.189 1.162h.11a5.227 5.227 0 0 1 3.484 5.813 5.293 5.293 0 0 1-5.23 4.363 5.811 5.811 0 0 1-.9 0 5.23 5.23 0 0 1 .833-10.409h.126L16.129 28.4l3.649-20.6a.751.751 0 0 1 .755-.635h6.385a.775.775 0 1 1 0 1.549h-5.74L17.7 28.4l7.629 13.7 18.384.077v-.108a8.45 8.45 0 0 1 7.863-6.2 8.319 8.319 0 0 1 8.052 7.946.786.786 0 0 1-1.573 0 6.8 6.8 0 0 0-6.479-6.412 6.837 6.837 0 0 0-6.542 6.428v1.8l1.227-.294v-.124a3.218 3.218 0 0 1 0-.4 5.28 5.28 0 0 1 4.718-5.235 3.455 3.455 0 0 1 .6-.139 5.263 5.263 0 0 1 0 10.517zm-37.743-9a3.7 3.7 0 0 0-.234 7.343h.6a3.747 3.747 0 0 0 3.741-2.912 3.688 3.688 0 0 0-2.168-4.182H15.6l-.346 2.076a1.825 1.825 0 0 1 .5 2.091 1.685 1.685 0 0 1-1.573.976H13.9a1.651 1.651 0 0 1-.3-3.191l.409-1.983v-.186zM48.148 46.3v.155a3.816 3.816 0 0 0 3.428 1.967 3.553 3.553 0 0 0 1.384-.279A3.693 3.693 0 0 0 55.3 44a3.745 3.745 0 0 0-3.724-3.009H51.1a3.753 3.753 0 0 0-3.3 3.671v.17l2.076-.5a1.883 1.883 0 0 1 1.73-1.3 1.708 1.708 0 0 1 1.573 1.27 1.648 1.648 0 0 1-.834 1.843 1.592 1.592 0 0 1-.8.2 1.759 1.759 0 0 1-1.227-.511zm-20.822-.666l16.135.077V43.7h-17.3z",
    className: "cls-3",
    transform: "translate(-8.798 -7.16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon_bicycle",
    transform: "translate(9418.766 1124.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    d: "M62.023 54.8a13.137 13.137 0 0 1-12.987-12.03h13.438a.995.995 0 0 0 .807-1.539l-7.338-10.96a13.025 13.025 0 1 1 6.08 24.529zM24.9 23.705l.206-1.126h22.879L42.2 38.288l-.432-2.271h.206a.976.976 0 0 0 0-1.877H39.2a.976.976 0 1 0 0 1.877h.582l.525 2.759zm29.447 7.62l6.362 9.475H49.036a13.137 13.137 0 0 1 5.311-9.475zm-1.089-1.633A15.014 15.014 0 0 0 47.14 40.8h-3.753l6.118-16.61zM30.193 41.8a13.025 13.025 0 1 1-13.025-13.028 12.856 12.856 0 0 1 4.429.769 33.782 33.782 0 0 1-5.18 11.617.979.979 0 1 0 1.5 1.257 31.586 31.586 0 0 0 5.142-10.848c.113-.413.244-.826.338-1.2A13.006 13.006 0 0 1 30.193 41.8zM62.1 26.783a15.014 15.014 0 0 0-7.169 1.877l-4.523-6.738 3-8.164a1.333 1.333 0 0 0 1.2.751 1.351 1.351 0 0 0 1.351-1.351 1.314 1.314 0 0 0-.807-1.239.826.826 0 0 0-.488-.131h-7.43a.976.976 0 1 0 0 1.877h4.016l-2.534 6.963H25.464l.863-4.842a.694.694 0 0 0 0-.338.525.525 0 0 0 0-.169.976.976 0 0 0-.976-.995h-7.319a3.284 3.284 0 0 0 0 6.569h2.177a.985.985 0 0 0 0-1.971H18.05a1.314 1.314 0 0 1 0-2.628h6.268l-1.538 8.427s-.206 1.22-.638 2.965a14.7 14.7 0 0 0-4.917-.826 15.014 15.014 0 1 0 6.756 1.6c.244-.976.413-1.783.544-2.384l16.422 16.212L42 47.634h-.225a.976.976 0 1 0 0 1.877h2.775a.976.976 0 0 0 0-1.877h-.563l-.9-4.861h4A15.014 15.014 0 1 0 62.1 26.8z",
    className: "cls-3",
    transform: "translate(-2.231 -11.75)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRideChosen);
export default __webpack_public_path__ + "static/media/ride-chosen.50777d434a4c4007dee768e663a16d1c.svg";
export { ForwardRef as ReactComponent };